import { useDispatch, useSelector } from 'react-redux';
import { InlineLink, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { openInNewTab, selectConfig } from '@app/redux';

import { Platform } from '@mfe/shared/schema-types';

import styles from '../styles.module.scss';

const LifelineNotice = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChangePlan');
  const { platform } = useSelector(selectConfig);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (platform === Platform.Web) {
      return;
    }

    e.preventDefault();
    dispatch(openInNewTab(t('plan.satelliteInternetLink')));
  };

  return (
    <div className={styles['life-line-details']}>
      <Txt variant="bodySmallRegular" component="span" color="subtle">
        {t('plan.lifelineText')}
        <InlineLink
          mx="4px"
          variant="primary"
          onClick={handleClick}
          href={t('plan.satelliteInternetLink')}
          target="_blank"
          data-cy="satelliteInternetLink"
        >
          {t('plan.lifelineLink')}
        </InlineLink>
      </Txt>
    </div>
  );
};

export default LifelineNotice;
